import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";

import "../Passport.css";

import LoginForm from "./LoginForm";

class Login extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    processGoogleResponse = (res: any) => {
        this.props.rootStore.profileStore.processGoogleLogin(res);
    };

    handleSubmit = (email: string, password: string) => {
        var component = this;
        this.props.rootStore.profileStore.login(email, password, function(
            logged_in: boolean
        ) {
            if (logged_in) {
                component.props.history.push("/");
            }
        });
    };

    render() {
        if (this.props.rootStore.profileStore.redirectTo) {
            const redirectTo = this.props.rootStore.profileStore.redirectTo;
            this.props.rootStore.profileStore.clearRedirect();
            return <Navigate to={redirectTo} />;
        }

        return (
            <LoginForm
                processGoogleResponse={this.processGoogleResponse}
                handleSubmit={this.handleSubmit}
                status={this.props.rootStore.profileStore.status}
                statusMessage={this.props.rootStore.profileStore.statusMessage}
                isLoggedIn={this.props.rootStore.profileStore.isLoggedIn}
            />
        );
    }
}

export default observer(Login);
